module.exports = __webpack_public_path__ + "static/img/2_2_3.8fbb1705.jpg";